import { computed } from '@vue/composition-api'
import type { Customer } from '@aspenware-library/types'
import { createSharedComposable, useAsyncState } from '@vueuse/core'

const cartState = () => {
  const { state, execute, isLoading } = useAsyncState<Customer | null>(
    () => fetch('/api/v1/customers/current').then((res) => res.json()),
    null,
    { immediate: false }
  )

  if (!state.value) {
    execute()
  }

  const customer = computed<Customer | null>(() => state.value)

  return {
    customer,
    loading: isLoading,
    load: execute,
  }
}

const useCart = createSharedComposable(cartState)
export default useCart
